import { module } from 'modujs';
import gsap from "gsap";
import { debounce } from '../utils/tickers';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                more: 'showMore'
            }
        }
    }

    init() {
        if (this.el.querySelectorAll('[data-collapse]')) {
            this.el.querySelectorAll('[data-collapse]').forEach((collapse) => {
                let collapseToggle = collapse.querySelector('[data-collapse-toggle]');
                let collapseContent = collapse.querySelector('[data-collapse-content]');
                collapseToggle.addEventListener('click', (e) => {
                    let contentHeight = collapse.querySelector('[data-collapse-content-inner]').offsetHeight;
                    collapse.toggleAttribute('data-collapse-opened');
                    gsap.to(collapseContent, {
                        height: collapse.hasAttribute('data-collapse-opened') ? contentHeight : 0,
                        ease: 'expo.out',
                        duration: 0.8,
                        onComplete: () => { 
                            this.call('resize', 'Scroll');
                        }
                    });
                })
            })
        }

        window.addEventListener(
            "resize",
            debounce(() => {
                this.resizeCollapsesContents()
            }, 10, false)
        );
    }

    resizeCollapsesContents() {
        if (this.el.querySelectorAll('[data-collapse-opened]')) {
            this.el.querySelectorAll('[data-collapse-opened]').forEach((collapse) => {
                let contentHeight = collapse.querySelector('[data-collapse-content-inner]').offsetHeight;
                collapse.querySelector('[data-collapse-content]').style.height = contentHeight + 'px';
            });
        }
    };

    showMore() {
        this.el.querySelector('.c-faqs_more').classList.add('-hidden');
        
        if (this.el.querySelectorAll('.c-faq.-hidden')) {
            this.el.querySelectorAll('.c-faq.-hidden').forEach((faq, index) => {
                faq.classList.remove('-hidden');
                setTimeout(() => {
                    faq.classList.add('is-inview');
                }, index * 100);
            });
        }
    }
}
